import { Link } from 'gatsby';
import React, { useState } from 'react';

const Navbar = ({ className }) => {
  const [toggleOn, toggle] = useState(false);
  return (
    <div className={`flex m-0  pt-4 ${className}`}>
      <div className="flex-grow">
        <Link to="/" className="flex">
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20.881 30.0823C19.1185 31.1246 17.1187 31.6985 15.0717 31.7495C14.8353 31.144 14.4719 30.5963 14.006 30.143C13.6116 29.7576 13.1496 29.4479 12.6432 29.2295C11.9081 28.9083 11.1017 28.7854 10.3043 28.8731C9.50694 28.9609 8.74651 29.2561 8.09888 29.7295C6.50591 28.6655 5.19078 27.2357 4.26346 25.5596C3.33614 23.8834 2.82358 22.0096 2.76861 20.0948C2.71365 18.18 3.11789 16.2798 3.94754 14.5532C4.77719 12.8266 6.00813 11.3237 7.53745 10.1702C7.97486 9.83873 8.43504 9.53846 8.91459 9.27161C8.91459 9.27161 8.91459 9.27161 8.92031 9.27161C8.92602 9.27161 8.92031 9.27161 8.92674 9.27161C8.97317 9.27161 9.02245 9.26589 9.06959 9.26589C9.48574 9.26606 9.88817 9.41471 10.2045 9.68509C10.5209 9.95547 10.7303 10.3298 10.7953 10.7409L11.8189 9.61804C12.0762 9.28064 12.4473 9.04814 12.8632 8.96375C12.9788 8.93982 13.0965 8.92809 13.2146 8.92875C13.679 8.92913 14.1242 9.11378 14.4526 9.44215C14.781 9.77052 14.9656 10.2158 14.966 10.6802C14.9663 10.8618 14.9378 11.0424 14.8817 11.2152L16.6303 9.46661C16.7088 9.24033 16.8334 9.0328 16.9962 8.85711C17.1589 8.68142 17.3564 8.5414 17.576 8.44589C17.7977 8.34465 18.0388 8.29297 18.2824 8.29446C18.6187 8.2948 18.9478 8.3918 19.2304 8.57391C19.5131 8.75603 19.7374 9.01557 19.8767 9.32161C19.9813 9.54869 20.0349 9.79589 20.0339 10.0459C20.0339 10.3992 19.9269 10.7443 19.7269 11.0356C19.527 11.327 19.2436 11.5509 18.9139 11.678L15.0996 17.0002L15.516 16.5845C15.7338 16.4267 15.986 16.3229 16.2517 16.2816C16.3441 16.2667 16.4375 16.2591 16.531 16.2588C16.9483 16.259 17.3519 16.4083 17.6689 16.6797C17.9859 16.9511 18.1957 17.3267 18.2603 17.739C18.3249 18.1513 18.2401 18.5731 18.0213 18.9285C17.8025 19.2839 17.464 19.5494 17.0667 19.6773C16.8937 19.7335 16.7129 19.7619 16.531 19.7616C16.4502 19.7618 16.3695 19.7558 16.2896 19.7438C15.6661 19.8494 15.0711 20.0829 14.5422 20.4296C14.0133 20.7764 13.5619 21.2287 13.2163 21.7584C12.8707 22.288 12.6384 22.8834 12.534 23.5072C12.4297 24.1309 12.4555 24.7695 12.6099 25.3828C12.7643 25.9961 13.0439 26.5708 13.4312 27.0708C13.8184 27.5707 14.305 27.9852 14.8601 28.288C15.4153 28.5909 16.0272 28.7756 16.6572 28.8306C17.2872 28.8855 17.9218 28.8095 18.521 28.6073C18.6936 28.666 18.8696 28.7137 19.0482 28.7502C19.6155 29.2513 20.2292 29.6974 20.881 30.0823Z"
              fill="#151515"
            />
            <path
              d="M19.3154 30.0821C21.0781 31.1244 23.0782 31.6983 25.1254 31.7492C25.3617 31.1438 25.7248 30.5961 26.1904 30.1428C26.5842 29.7564 27.0457 29.4458 27.5519 29.2263C28.2869 28.9051 29.0934 28.7823 29.8907 28.87C30.6881 28.9577 31.4485 29.253 32.0961 29.7263C33.6891 28.6624 35.0042 27.2326 35.9316 25.5564C36.8589 23.8803 37.3715 22.0064 37.4264 20.0916C37.4814 18.1768 37.0771 16.2767 36.2475 14.5501C35.4178 12.8235 34.1869 11.3206 32.6576 10.1671C32.2207 9.83542 31.7609 9.53492 31.2819 9.26777C31.2819 9.26777 31.2819 9.26777 31.2761 9.26777C31.2704 9.26777 31.2726 9.26777 31.2697 9.26777C31.2233 9.26777 31.174 9.26206 31.1269 9.26206C30.7107 9.26223 30.3083 9.41087 29.9919 9.68125C29.6756 9.95164 29.4661 10.326 29.4011 10.7371L28.3776 9.6142C28.1201 9.27661 27.7487 9.04408 27.3326 8.95992C27.2189 8.93629 27.103 8.92456 26.9869 8.92492C26.5225 8.9253 26.0772 9.10994 25.7488 9.43832C25.4205 9.76669 25.2358 10.212 25.2354 10.6763C25.2333 10.8587 25.26 11.0402 25.3147 11.2142L23.5661 9.46563C23.4876 9.23936 23.3631 9.03182 23.2003 8.85613C23.0375 8.68045 22.8401 8.54043 22.6204 8.44492C22.3988 8.34368 22.1577 8.292 21.914 8.29349C21.5777 8.29373 21.2486 8.3907 20.9659 8.57282C20.6833 8.75495 20.4589 9.01454 20.3197 9.32063C20.2151 9.54771 20.1615 9.79492 20.1626 10.0449C20.1633 10.3983 20.271 10.7432 20.4716 11.0342C20.6721 11.3251 20.9561 11.5485 21.2861 11.6749L25.0961 16.9999L24.6804 16.5842C24.4624 16.4263 24.21 16.3225 23.944 16.2813C23.8517 16.2664 23.7583 16.2587 23.6647 16.2585C23.2474 16.2589 22.844 16.4083 22.5271 16.6797C22.2102 16.9512 22.0006 17.3269 21.9361 17.7391C21.8716 18.1514 21.9564 18.5731 22.1752 18.9284C22.394 19.2837 22.7325 19.5492 23.1297 19.6771C23.3025 19.7331 23.4831 19.7616 23.6647 19.7613C23.7458 19.7616 23.8267 19.7556 23.9069 19.7435C24.5304 19.8491 25.1253 20.0827 25.6542 20.4294C26.1831 20.7761 26.6346 21.2285 26.9802 21.7581C27.3258 22.2877 27.5581 22.8832 27.6624 23.5069C27.7668 24.1307 27.7409 24.7692 27.5865 25.3825C27.4321 25.9958 27.1525 26.5705 26.7653 27.0705C26.378 27.5705 25.8915 27.9849 25.3363 28.2878C24.7811 28.5906 24.1693 28.7753 23.5393 28.8303C22.9092 28.8852 22.2747 28.8092 21.6754 28.6071C21.5029 28.6657 21.3268 28.7134 21.1483 28.7499C20.581 29.2511 19.9672 29.6971 19.3154 30.0821Z"
              fill="#151515"
            />
          </svg>
          <span className="headline-6  p-2">Kyosimba</span>
        </Link>
      </div>
      <nav>
        <button
          onClick={() => toggle(!toggleOn)}
          className="lg:hidden p-0 active:shadow-lg mouse transition ease-in duration-200 focus:outline-none text-center"
        >
          <svg
            width="32"
            height="32"
            viewBox="0 0 49 49"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.34961 26.9498H41.6496V22.0498H7.34961V26.9498ZM7.34961 39.1998H41.6496V34.2998H7.34961V39.1998ZM7.34961 9.7998V14.6998H41.6496V9.7998H7.34961Z"
              fill="black"
            />
          </svg>
        </button>
        <ul
          className={`lg:flex list-none lg:flex-row  flex-col lg:relative absolute top-10 pt-4 lg:pt-0 right-0  lg:top-0 bg-white lg:bg-transparent  ${
            toggleOn ? 'block' : 'hidden'
          }`}
        >
          <li>
            <a
              href="//www.facebook.com/kyosimbatech"
              target="__blank"
              rel="noopener noreferrer"
              className="headline-6  inline-block p-2 py-4 lg:py-2"
            >
              Projects
            </a>
          </li>
          <li>
            <a
              href="//www.facebook.com/kyosimbatech"
              target="__blank"
              rel="noopener noreferrer"
              className="headline-6 inline-block p-2 py-4 lg:py-2"
            >
              Blog
            </a>
          </li>
          <li>
            <a
              href="//www.facebook.com/kyosimbatech"
              target="__blank"
              rel="noopener noreferrer"
              className="headline-6 inline-block p-2 py-4 lg:py-2"
            >
              Events
            </a>
          </li>
          <li>
            <a
              href="//www.facebook.com/kyosimbatech"
              target="__blank"
              rel="noopener noreferrer"
              className="headline-6 inline-block  p-2 py-4 lg:py-2"
            >
              Subscribe
            </a>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Navbar;
